// ========================================================================
// 📁 ApprovalActions.js (Can be a sub-component within JobSection)
// Purpose: Handles the logic for displaying approval status or action buttons.
// ========================================================================
import { Button } from "@blueprintjs/core";
import {XCircle, Check, CheckCircle2, AlertTriangle} from "lucide-react";
import React, {useState} from "react";
import {BRANDS} from "./constants";

export const ApprovalActions = ({ sentForApproval, data, defaultBrand, onApprove, onDeny, share, onBrandUpdate }) => {
    const { approved, rejectedReason } = data || {};

    if (approved === true) {
        return <StatusDisplay isApproved={true} reason={rejectedReason} />;
    }
    if (approved === false) {
        return <StatusDisplay isApproved={false} reason={rejectedReason} />;
    }

    // If pending and not in share mode, show buttons
    if (share) return null;

    return (
        <div className="flex space-x-3">

            { sentForApproval ? (
                <>
                    <Button
                        onClick={onApprove}
                        className="flex-1 bg-green-500 hover:bg-green-600 text-white py-3 px-4 rounded-lg transition-all duration-200 hover:scale-105"
                    >
                        <Check className="w-4 h-4 mr-2"/>
                        Approve
                    </Button>
                    <Button
                        onClick={onDeny}
                        className="flex-1 bg-red-500 hover:bg-red-600 text-white py-3 px-4 rounded-lg transition-all duration-200 hover:scale-105"
                    >
                        <XCircle className="w-4 h-4 mr-2"/>
                        Deny
                    </Button>
                </>
            ) : (
                <div className="bg-amber-50 border w-full border-amber-200 rounded-lg p-4">
                    <div className="flex items-center space-x-3">
                        <AlertTriangle className="w-5 h-5 text-amber-600" />
                        <p className="text-amber-800 font-medium">Not Sent for Approval</p>
                    </div>
                </div>
            )}


        </div>
    );
};

export const StatusDisplay = ({ isApproved, reason }) => (
    <div className={`rounded-lg p-3 ${isApproved ? 'bg-green-50 border border-green-200' : 'bg-red-50 border border-red-200'}`}>
        <div className="flex items-start space-x-3">
            {isApproved ? <CheckCircle2 className="w-5 h-5 text-green-600" /> : <XCircle className="w-5 h-5 text-red-600" />}
            <div>
                <p className={`font-semibold ${isApproved ? 'text-green-800' : 'text-red-800'}`}>
                    {isApproved ? 'Approved' : 'Denied'}
                </p>
                {reason && <p className="text-sm text-gray-600 mt-1"><strong>Reason:</strong> {reason}</p>}
            </div>
        </div>
    </div>
);

export const NoDataMessage = ({ message = 'No data available' }) => (
    <div className="bg-white/50 rounded-lg p-6 text-center text-gray-500">
        <AlertTriangle className="w-10 h-10 mx-auto mb-2 text-gray-400" />
        <p className="font-medium">{message}</p>
    </div>
);
